import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row d-flex align-items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-4" }, "History of Vacation Benefits Paid"),
    /*#__PURE__*/_createElementVNode("p", null, "This is a history of checks sent to you that were due for vacation benefits.")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "table table-bordered table-striped"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "row-1" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Check #"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Gross Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Admin Fee"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Amount")
  ])
], -1)
const _hoisted_5 = {
  key: 1,
  class: "col-md-12 text-center my-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " There are no vacation checks to be found for the selected period", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:history.back()",
  class: "btn btn-primary"
}, "Back", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.checks.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.checks, (check, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(check.CheckNumber), 1),
                _createElementVNode("td", null, _toDisplayString(check.CheckDate), 1),
                _createElementVNode("td", null, "$" + _toDisplayString(check.Amount.Gross), 1),
                _createElementVNode("td", null, "$" + _toDisplayString(check.Amount.AdminFee), 1),
                _createElementVNode("td", null, "$" + _toDisplayString(check.Amount.PaymentAmount), 1)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
    _hoisted_8
  ]))
}